import type { IVariable } from "@bbj-types/utils";
import { Stack, Typography } from "@mui/material";
import { EditorV2 } from "@styleguide";
import { type Control, Controller, type UseFormGetValues } from "react-hook-form";
import type { INotifyBySmsModalForm } from "../types";

export interface ISmsContentProps {
  control: Control<INotifyBySmsModalForm, void>;
  getValues: UseFormGetValues<INotifyBySmsModalForm>;
  variables: IVariable[];
}

export const SmsContent = ({ control, getValues, variables }: ISmsContentProps) => {
  return (
    <Controller
      control={control}
      name="content"
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        return (
          <Stack
            sx={{
              width: 424,
            }}
          >
            <EditorV2
              key={`${getValues("type")}`}
              onChange={(html, text) => {
                onChange({ ...value, html: html, text: text === "\n" ? "" : text.slice(0, 400) });
              }}
              toolbar={"variable"}
              value={value.html}
              maxCharLimit={400}
              init={{
                // biome-ignore lint/style/useNamingConvention: <explanation>
                max_height: 380,
              }}
              variableList={variables}
            />
            {error?.message && (
              <Typography
                sx={[
                  {
                    ml: 2,
                  },
                  (theme) => ({ color: theme.palette.error.main }),
                ]}
              >
                {error.message}
              </Typography>
            )}
            <Typography
              sx={[
                {
                  display: "flex",
                  justifyContent: "end",
                },
                (theme) => ({ color: theme.palette.primary.light }),
              ]}
            >
              {value.text?.length}/400 caractères
            </Typography>
          </Stack>
        );
      }}
    />
  );
};
